import React from "react";
import { logosLoop, stats } from "../../v3/data";

const TrustStrip = () => (
  <section style={{ borderTop: "1px solid var(--line)", borderBottom: "1px solid var(--line)" }}>
    <div className="marq" style={{ padding: "26px 0", borderBottom: "1px solid var(--line)" }}>
      <div className="marq-inner">
        {logosLoop.map((l, i) => (
          <span key={i} className="fx ac gap16">
            <span className="disp fw7" style={{ fontSize: 19, color: "#94A3B8", whiteSpace: "nowrap" }}>
              {l}
            </span>
            <span className="mono" style={{ color: "var(--accent-line)", fontSize: 14 }}>
              /
            </span>
          </span>
        ))}
      </div>
    </div>
    <div className="pagewrap">
      <div className="stat-grid">
        {stats.map((s) => (
          <div key={s.label} className="statcell">
            <div className="disp fw7" style={{ fontSize: 44, letterSpacing: "-.02em" }}>
              <span className="statnum" data-target={s.num}>
                {s.num}
              </span>
              <span style={{ color: "var(--accent)" }}>{s.suffix}</span>
            </div>
            <div className="mono" style={{ fontSize: 11.5, color: "var(--muted)", marginTop: 6, letterSpacing: ".1em" }}>
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TrustStrip;
